const removeFooter = ({ el }) => {
   const footer = document.querySelector('[data-footer]');
   footer.classList.add('hidden');
}

export default removeFooter;